const styles = `:host([aria-selected=true]) {
  color: var(--goto-type-color-default);
  font: var(--goto-body-medium-strong);
}

:host {
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  box-sizing: border-box;
  outline: none;
  border-radius: var(--goto-radius-small);
  white-space: normal;
  color: var(--goto-type-color-secondary);
  border-color: transparent;
  background-color: transparent;
  --goto-icon-color: var(--goto-icon-color-default);
  font: var(--goto-body-medium);
  height: var(--goto-spacing-07);
  width: 100%;
  align-items: center;
  display: inline-flex;
  justify-content: center;
  padding: var(--goto-spacing-01) var(--goto-spacing-03);
  width: unset;
}

:host(:hover) {
  border-color: transparent;
  background-color: var(--goto-interactive-color-secondary-hover);
}

:host(:active) {
  border-color: transparent;
  background-color: var(--goto-interactive-color-secondary-pressed);
  box-shadow: none;
}

:host(:focus-visible) {
  border-color: var(--goto-border-color-default);
  box-shadow: var(--goto-highlight);
}

:host(.disabled) {
  border-width: 1px;
  border-style: solid;
  cursor: pointer;
  box-sizing: border-box;
  outline: none;
  border-radius: var(--goto-radius-small);
  white-space: normal;
  color: var(--goto-type-color-disabled);
  border-color: transparent;
  background-color: transparent;
  --goto-icon-color: var(--goto-icon-color-default);
  font: var(--goto-body-medium);
  height: var(--goto-spacing-07);
  width: 100%;
  pointer-events: none;
}

::slotted(chameleon-badge) {
  margin-left: var(--goto-spacing-01);
}`; export default styles;